// Code-readable status names to status strings from backend
export const AUTHORIZATION_STATUSES = {
  draft: 'draft',
  open: 'requested',
  accepted: 'approved',
  rejected: 'denied',
  autoAccepted: 'auto_approved',
  inReview: 'in_review',
  void: 'void',
};

export const ALL_AUTHORIZATION_PAGE_STATUSES = [
  AUTHORIZATION_STATUSES.open,
  AUTHORIZATION_STATUSES.accepted,
  AUTHORIZATION_STATUSES.rejected,
  AUTHORIZATION_STATUSES.inReview,
].join(',');

export const ALL_AUTHORIZATION_PAGE_STATUSES_WITH_VOID = [
  AUTHORIZATION_STATUSES.open,
  AUTHORIZATION_STATUSES.accepted,
  AUTHORIZATION_STATUSES.rejected,
  AUTHORIZATION_STATUSES.inReview,
  AUTHORIZATION_STATUSES.void,
].join(',');

export const OPEN_AUTHORIZATION_PAGE_STATUSES = [
  AUTHORIZATION_STATUSES.open,
  AUTHORIZATION_STATUSES.inReview,
].join(',');

// Code-readable (for programmers use) status names to human-readable status names
export const AUTHORIZATION_STATUSES_TEXT = {
  draft: 'draft',
  open: 'open',
  accepted: 'accepted',
  rejected: 'rejected',
  autoAccepted: 'auto_accepted',
  inReview: 'in_review',
  void: 'void',
};

// Status strings from backend to human-readable status text
export const AUTHORIZATION_STATUSES_TO_TEXT = {
  draft: 'Draft',
  open: 'Open',
  requested: 'Requested',
  approved: 'Accepted',
  auto_approved: 'Auto Accepted',
  denied: 'Rejected',
  deferred: 'Deferred',
  in_review: 'In Review',
  void: 'Voided',
};

export const AUTHORIZATION_STATUSES_TO_COLOR = {
  draft: '#525F73',
  requested: '#F4D316',
  approved: '#4ECE3D',
  denied: '#CF2A2A',
  deferred: '#CF2A2A',
  in_review: '#FF8C00',
  void: '#4467AB',
};
